import { Component, OnInit } from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {distinctUntilChanged, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'db-cdn-full-page-cache',
    templateUrl: './cdn-full-page-cache.component.html',
    styleUrls: ['./cdn-full-page-cache.component.scss'],
    standalone: false
})
export class CdnFullPageCacheComponent implements OnInit {

  public websiteId: number;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
    this._getCFData();
  }

  private _getCFData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        distinctUntilChanged((cdnOldData: any, cdnNewData: any) => cdnOldData && cdnNewData && JSON.stringify(cdnOldData) === JSON.stringify(cdnNewData)),
        takeUntil(this._destroyStream$)
      )
      .subscribe(data => {
      });
  }
}
